import axios from "axios";

export function getReceiveTransferSenderDropdown(params) {
  return new Promise((resolve, reject) => {
    axios
      .get(`/distributor/admin/api/v1/receive-transfer/get-sender-dropdown`, {
        params,
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
